'use client';

import { JSX } from 'react';

import { GoogleLoginOneTouchButton } from '../../../components/google-login/GoogleLoginOneTouchButton';
import { useGoogleSignInCallback } from './useGoogleSignInCallback';

type Props = {
    redirectAfterLogin?: string;
};

export function GoogleLoginButton({ redirectAfterLogin }: Props): JSX.Element | null {
    const callback = useGoogleSignInCallback(redirectAfterLogin);
    if (typeof window === 'undefined') {
        return null;
    }
    return (
        <div className="flex flex-row items-center justify-center w-full">
            <GoogleLoginOneTouchButton successCallback={callback} />
        </div>
    );
}
